// extracted by mini-css-extract-plugin
export var actions = "_aw-8";
export var arrow = "_aw-5";
export var card = "_aw-0";
export var cardWrapper = "_aw-9";
export var fieldName = "_aw-3";
export var newValue = "_aw-6";
export var oldValue = "_aw-4";
export var orangeGlowFade = "_aw-c";
export var productSection = "_aw-1";
export var scrollToBottom = "_aw-b";
export var scrollToBottomAnchor = "_aw-a";
export var scrollToBottomIcon = "_aw-d";
export var showAllButton = "_aw-7";
export var table = "_aw-2";